import { render, staticRenderFns } from "./ParticipantsTable.vue?vue&type=template&id=dece1e78"
import script from "./ParticipantsTable.vue?vue&type=script&lang=ts"
export * from "./ParticipantsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports